export default __webpack_public_path__ + "static/hiv-landscape-section_hero-desktop-22702401d6f7731745a5658ef19e8199.jpg";